import React from 'react';
import styled from 'styled-components';
import { OrderStatusEmptyIcon, SkilletIcon } from '../card/card-icon';
const WrapIconSkillet = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 24px;
  height: 100vh;
`;
const WrapContent = styled.div `
  min-width: 176px;
  min-height: 176px;
  border-radius: 50%;
  gap: 24px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const WrapOrderStatus = styled.div `
  min-width: 56px;
  min-height: 56px;
  border-radius: 50%;
  padding: 16px;
  background: #dfdfdf;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const StatusTxt = styled.div `
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  color: #6b7270;
`;
export const NoItemOders = () => {
    return (React.createElement(WrapIconSkillet, { className: 'm-t-5' },
        React.createElement(WrapContent, null,
            React.createElement("div", null,
                React.createElement(SkilletIcon, null)),
            React.createElement("p", null, "No orders found"))));
};
export const OrderStatusEmpty = () => {
    return (React.createElement(WrapIconSkillet, { className: "m-t-5" },
        React.createElement(WrapOrderStatus, null,
            React.createElement("div", null,
                React.createElement(OrderStatusEmptyIcon, null))),
        React.createElement(StatusTxt, null, "Order status empty")));
};
//# sourceMappingURL=index.js.map